/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

// NOTE: Distribution list search is for pending requests, not all DLs per tenant
export const DISTRIBUTION_LISTS_SEARCH = "DISTRIBUTION_LISTS_SEARCH";
export const DISTRIBUTION_LISTS_SEARCH_SUCCESS = "DISTRIBUTION_LISTS_SEARCH_SUCCESS";
export const DISTRIBUTION_LISTS_SEARCH_FAIL = "DISTRIBUTION_LISTS_SEARCH_FAIL";

export const DISTRIBUTION_LISTS_RESET = "DISTRIBUTION_LISTS_RESET";

export const UPDATE_DISTRIBUTION_LISTS_LISTING_CURRENT_PAGE =
  "UPDATE_DISTRIBUTION_LISTS_LISTING_CURRENT_PAGE";
export const UPDATE_DISTRIBUTION_LISTS_LISTING_PAGE_SIZE =
  "UPDATE_DISTRIBUTION_LISTS_LISTING_PAGE_SIZE";

export const APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST =
  "APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST";
export const APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST_SUCCESS =
  "APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST_SUCCESS ";
export const APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST_FAIL =
  "APPROVE_OR_DECLINE_DISTRIBUTION_LIST_JOIN_REQUEST_FAIL";

export const FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST =
  "FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST";
export const FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST_SUCCESS =
  "FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST_SUCCESS";
export const FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST_FAIL =
  "FETCH_DISTRIBUTION_LISTS_BY_TENANT_REQUEST_FAIL";

export const UPDATE_SELECTED_DISTRIBUTION_LIST = "UPDATE_SELECTED_DISTRIBUTION_LIST";
export const UPDATE_SELECTED_DISTRIBUTION_LIST_FAIL = "UPDATE_SELECTED_DISTRIBUTION_LIST_FAIL";
export const UPDATE_SELECTED_DISTRIBUTION_LIST_SUCCESS =
  "UPDATE_SELECTED_DISTRIBUTION_LIST_SUCCESS";

export const FETCH_MICROSOFT_MEMBERS_FOR_DL = "FETCH_MICROSOFT_MEMBERS_FOR_DL";
export const FETCH_MICROSOFT_MEMBERS_FOR_DL_FAIL = "FETCH_MICROSOFT_MEMBERS_FOR_DL_FAIL";
export const FETCH_MICROSOFT_MEMBERS_FOR_DL_SUCCESS = "FETCH_MICROSOFT_MEMBERS_FOR_DL_SUCCESS";

export const ADD_MICROSOFT_MEMBER_TO_DL = "ADD_MICROSOFT_MEMBER_TO_DL";
export const ADD_MICROSOFT_MEMBER_TO_DL_FAIL = "ADD_MICROSOFT_MEMBER_TO_DL_FAIL";
export const ADD_MICROSOFT_MEMBER_TO_DL_SUCCESS = "ADD_MICROSOFT_MEMBER_TO_DL_SUCCESS";

export const REMOVE_MICROSOFT_MEMBER_FROM_DL = "REMOVE_MICROSOFT_MEMBER_FROM_DL";
export const REMOVE_MICROSOFT_MEMBER_FROM_DL_FAIL = "REMOVE_MICROSOFT_MEMBER_FROM_DL_FAIL";
export const REMOVE_MICROSOFT_MEMBER_FROM_DL_SUCCESS = "REMOVE_MICROSOFT_MEMBER_FROM_DL_SUCCESS";

export const MICROSOFT_MEMBER_DL_RESET = "MICROSOFT_MEMBER_DL_RESET";
